import { ReactElement } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import DropdownCustom from '../../controls/DropdownCustom';
import AlertGraphCell from '../AlertGraphCell';
import Procard from '../Procard';

const DEFAULT_DROPDOWN_PLACEHOLDER = 'Select Rule';

type ZommedAlertAnalyticsProps = {
  onBackPress?: () => void;
  selectedRule: string;
  setSelectedRule: (value: string) => void;
  devicesData: any[];
  loading: boolean;
};

/**
 * React component for AlertAnalytics.
 * @param props - Properties of AlertAnalytics component.
 * @returns - React component for AlertAnalytics.
 */
export default function ZoomedAlertAnalytics(props: ZommedAlertAnalyticsProps): ReactElement {
  const { onBackPress, selectedRule, setSelectedRule, devicesData, loading } = props;

  const DROPDOWN_PLACEHOLDER =
    selectedRule.length > 0 ? selectedRule : DEFAULT_DROPDOWN_PLACEHOLDER;
  return (
    <RawDataOverviewContainer
      loading={loading}
      size="full"
      onBackPress={onBackPress}
      sectionName="Analytics"
      zoomed
    >
      <div className="flex flex-1 flex-col">
        <div className="flex items-center gap-5 mt-2">
          <div className="flex items-center gap-2">
            <div className="font-medium dark:text-gray-300 text-black">Alert Analytics</div>
            <Procard />
          </div>
          <DropdownCustom
            onClick={setSelectedRule}
            controlPlaceholder={DROPDOWN_PLACEHOLDER}
            buttons={[]}
          />
        </div>
        <div className="flex mt-8 gap-16">
          <div>
            <div className="flex gap-12">
              <div className="dark:text-gray-300 text-[#808080] font-semibold text-base flex flex-col gap-4">
                <div>Created on</div>
                <div>Priority</div>
                <div>Assigned to</div>
                <div>Lower threshold</div>
              </div>
              <div className="dark:text-gray-500 text-black font-semibold text-base flex flex-col gap-4 text-right">
                <div>Pending resolution</div>
                <div>High</div>
                <div>Abijithk97</div>
                <div>1atm</div>
              </div>
            </div>
          </div>
          <div>
            <div className="flex gap-12">
              <div className="dark:text-gray-300 text-[#808080] font-semibold text-base flex flex-col gap-4">
                <div>Parameter</div>
                <div>Device/Group</div>
                <div>Aggregation period</div>
                <div>Higher threshold</div>
              </div>
              <div className="dark:text-gray-500 text-black font-semibold text-base flex flex-col gap-4 text-right">
                <div>Pressure</div>
                <div>High</div>
                <div>Realtime</div>
                <div>2atm</div>
              </div>
            </div>
          </div>
        </div>
        <div className="dark:text-gray-300 text-black font-medium mt-8">Alert Details</div>
        <div className="flex-1 flex flex-col justify-evenly  mt-4">
          {devicesData.map((item) => (
            <div
              className="w-full p-3 flex items-center border border-gray-800 rounded"
              key={item.name}
            >
              <div className="text-gray-300 text-xs font-medium">{item.name}</div>
              <div className="flex flex-col w-full ml-6 gap-2">
                <div className="flex gap-1 justify-between w-full">
                  {item.data.map((cellValue: number, index: number) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <AlertGraphCell key={index} cellValue={cellValue} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </RawDataOverviewContainer>
  );
}
